var React = require('react');

function CassetteTape (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M147.78 384l-32 64h280.44l-32-64zM464 64H48a48 48 0 0 0-48 48v288a48 48 0 0 0 48 48h32l48-96h256l48 96h32a48 48 0 0 0 48-48V112a48 48 0 0 0-48-48zm-96 224H144a64 64 0 0 1 0-128h224a64 64 0 0 1 0 128z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M368 160H144a64 64 0 0 0 0 128h224a64 64 0 0 0 0-128zm-224 80a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm61.73 0a57.52 57.52 0 0 0 0-32h100.54a57.52 57.52 0 0 0 0 32zM368 240a16 16 0 1 1 16-16 16 16 0 0 1-16 16z","className":"fa-primary","key":2})]);
}

CassetteTape.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CassetteTape;

CassetteTape.default = CassetteTape;
